import React, { useState } from "react";
import { Plus, Check } from "lucide-react";
import { useCart } from "@/lib/cartStore";

/**
 * Bouton inline "Ajouter au récap" — feedback visuel court (Check) après ajout.
 *
 * Props :
 *  - item: { kind?, name, details?, unitPrice }  (passé à useCart().addItem)
 *  - testId: string  — data-testid de base
 *  - size: "sm" | "md"  — variantes de padding
 *  - variant: "primary" | "outline"
 *  - label: string  — texte par défaut "Ajouter au récap"
 */
export const AddToCartButton = ({
  item,
  testId,
  size = "sm",
  variant = "outline",
  label = "Ajouter au récap",
  fullWidth = false,
  onAdded,
}) => {
  const { addItem } = useCart();
  const [added, setAdded] = useState(false);

  const handle = () => {
    if (!item || !item.name) return;
    addItem(item);
    setAdded(true);
    if (onAdded) onAdded();
    window.setTimeout(() => setAdded(false), 1400);
  };

  const sizing =
    size === "md"
      ? "px-4 py-2.5 text-sm"
      : "px-3 py-1.5 text-[11px]";

  const base =
    "font-street inline-flex items-center justify-center gap-1.5 rounded-md tracking-wider whitespace-nowrap transition-colors";

  const width = fullWidth ? "w-full" : "";

  const skin = added
    ? "border border-[#22C55E]/60 bg-[#22C55E]/15 text-[#86EFAC]"
    : variant === "primary"
    ? "bg-[#FF9500] text-black hover:bg-[#FFB347]"
    : "border border-[#FF9500]/40 bg-[#FF9500]/5 text-[#FF9500] hover:bg-[#FF9500]/15";

  return (
    <button
      type="button"
      onClick={handle}
      data-testid={testId}
      aria-label={label}
      className={`${base} ${sizing} ${skin} ${width}`}
    >
      {added ? (
        <>
          <Check size={size === "md" ? 14 : 11} strokeWidth={2.8} />
          Ajouté
        </>
      ) : (
        <>
          <Plus size={size === "md" ? 14 : 11} strokeWidth={2.6} />
          {label}
        </>
      )}
    </button>
  );
};

export default AddToCartButton;
